import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import campImg from "../../Assets/camp1.png";
import Tilt from "react-parallax-tilt";


import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";


function Camps2() {

  const navigate = useNavigate(); // Initialize navigate

  const handleClick = () => {
    navigate("/registration#techcamps-section"); // This will navigate to the "/another-page" route
  };




    const videoId = "5mPU-mIQgoQ"; 
return (
    <Container fluid className="home-about-section" id="about">
    <Container>
        <Row>
        <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
           TECH<span className="purple"> CAMPS</span> 
            </h1>
            <p className="home-about-body">
            At Choicest Fruit<span className="small-r-symbol">®</span>, our Tech Camps give kids and teens ages 8–17 the chance to dive into coding,
             robotics, electronics, and creative projects in a fun, supportive, and hands-on environment.
              These immersive, multi-day or week-long camps combine creativity and teamwork with practical
               skills that prepare youth to explore technology’s role in shaping communities.
            <br />
            <br />During our Tech Camps, participants explore a wide range of activities that spark 
            creativity and build practical skills. Campers dive into coding and app development by creating 
            hands-on projects in JavaScript, Python, and beginner-friendly platforms. They get introduced to
             robotics and electronics as they design circuits, build simple robots, and experiment with 
             interactive tech. Through creative tech projects, youth design games, animations, and digital 
             art while mastering the fundamentals of technology. The camps also emphasize STEM and 
             sustainability, encouraging participants to apply their skills to real-world challenges 
             such as urban gardening or environmental solutions. Along the way, they strengthen their 
             abilities in teamwork and problem-solving by collaborating in small groups to complete 
             challenges and present their projects.
          
            <br />
            <br />
            
          </p>
          <Button onClick={handleClick}>Register Here</Button>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={campImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>SUMMER INTERNSHIP PROGRAM</h1>
          <Container>    
      
        <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', maxWidth: '100%', marginBottom: '20px' }}>
                                <iframe
                                    title="YouTube video"
                                    src={`https://www.youtube.com/embed/${videoId}`}
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                    style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                    }}
                                />
      </div>
    </Container>
           
          </Col>
            </Row>

            
                <Col md={12} className="home-testimonial">
                <h1>TESTIMONIALS</h1>
                </Col>
          
            


      </Container>
    </Container>
  );
}
export default Camps2;
